import SetupMfa from "./SetupMfa.container";

export default SetupMfa;